import React, { useState } from 'react';
import ApplicationModal from './ApplicationModal';

const WeAreExpanding = () => {
  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false);

  const handleApplyClick = () => {
    setIsApplicationModalOpen(true);
  };

  return (
    <>
      <section className="py-20 relative overflow-hidden" style={{
        background: 'linear-gradient(to top left, #3A3A3A, #5A5A5A)'
      }}>
        {/* Subtle topographic pattern overlay */}
        <div className="absolute inset-0 opacity-10 bg-topographic"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Content */}
            <div className="animate-slide-in-left">
              <h2 className="text-4xl font-bold text-kiloterra-yellow mb-8 uppercase">
                We Are Expanding.
              </h2>
              {/* Yellow horizontal line */}
              <div className="flex mb-8">
                <div className="w-16 h-1 bg-kiloterra-yellow"></div>
              </div>
              <p className="text-xl text-gray-200 mb-8 leading-relaxed">
                KILOTERRA agents regularly close more deals and earn more commission than their competition. Now, we are bringing our proven systems to new areas, so we can help more people build a career in land sales and reach real financial freedom.
              </p>
              <p className="text-xl text-gray-200 mb-8 leading-relaxed">
                We're looking for highly motivated individuals in Missouri, Kansas, Nebraska, and a few select regions in Iowa.
              </p>
              <button 
                onClick={handleApplyClick}
                className="bg-kiloterra-yellow text-kiloterra-dark px-12 py-4 font-bold text-lg hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105 uppercase tracking-wide"
              >
                Apply Now
              </button>
            </div>

            {/* Right Column - Interactive Map */}
            <div className="animate-slide-in-right">
              <div className="bg-white p-8 shadow-lg">
                {/* Territory Map - New Version */}
                <div className="relative w-full mb-6">
                  <img
                    src="/KILOTERRA_ExpansionMap.jpg"
                    alt="KILOTERRA Territory Expansion Map"
                    className="w-full h-auto"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ApplicationModal 
        isOpen={isApplicationModalOpen} 
        onClose={() => setIsApplicationModalOpen(false)}
        source="we_are_expanding"
      />
    </>
  );
};

export default WeAreExpanding;